import axios from 'redaxios';

import slideDown from '../util/slide-down';
import slideUp from '../util/slide-up';

let sections = {};

const selectors = {
  wrapper: '[data-add-action-wrapper="bundle"]',
  addButton: '[data-add-to-cart]',
  errors: '[data-add-action-errors]',
  addVariantDetached: 'data-add-to-cart-variant',
  popdown: '[data-product-add-popdown-wrapper]',
};

const classes = {
  loading: 'loading',
  success: 'has-success',
};

class ProductAddButton {
  constructor(wrapper, isCartItem) {
    this.wrapper = wrapper;
    this.isCartItem = isCartItem ? isCartItem : false;
    this.button = wrapper.querySelector(selectors.addButton);
    this.errors = wrapper.querySelector(selectors.errors);
    this.popdown = document.querySelector(selectors.popdown);

    if (this.button) {
      this.initWithForm();
    }
  }

  initWithForm() {
    this.button.addEventListener(
      'click',
      function (evt) {
        evt.preventDefault();

        let bulkAddData = {
         'items': []
        };

        evt.target.closest(`[data-section-type="product-bundle"]`).querySelectorAll(`[data-bundle-item-add="true"]`).forEach((productSection) => {
          this.button.setAttribute('disabled', true);
          this.button.classList.add(classes.loading);

          const form =  productSection.querySelector(`[action="/cart/add"]`);
          const formData = new FormData(form);
          const formObject = {};
          formData.forEach(function(value, key){
            formObject[key] = value;
          });

          // const formString = new URLSearchParams(formData).toString();
          const variantId = formObject.id,
                item = {
                  'id': variantId,
                  'quantity': 1,
                  'properties': {
                    '_bundleProduct': 'Yes'
                  }
                };
          bulkAddData.items.push(item);
        });

        // console.log(bulkAddData);
        this.addToCartAction(bulkAddData);
      }.bind(this)
    );
  }

  addToCartAction(formData) {
    const url = `${window.theme.routes.cart}/add.js`;
    const instance = this;
    axios
      .post(url, formData, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then(function (response) {
        window.location.href = ' /cart';
        // instance.onSuccess(response.data);
      })
      .catch(function (error) {
        console.warn(error);
        instance.onError(error.data);
      });
  }

  onSuccess(variant) {
    this.updateHeaderTotal();
    this.button.classList.remove(classes.loading);
    this.button.classList.add(classes.success);
    setTimeout(() => {
      this.button.classList.remove(classes.success);
      this.button.removeAttribute('disabled');
    }, 3500);

    if (this.isCartItem) {
      document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
    } else {
      this.popdown.dispatchEvent(
        new CustomEvent('theme:cart:popdown', {
          detail: {
            variant: variant,
          },
          bubbles: true,
        })
      );
    }
  }

  onError(data) {
    let text = 'Network error: please try again';
    if (data && data.description) {
      text = data.description;
    }
    const errorsHTML = `<div class="errors">${text}</div>`;

    this.button.classList.remove(classes.loading);
    this.button.removeAttribute('disabled');
    this.errors.innerHTML = errorsHTML;
    slideDown(this.errors);
    setTimeout(() => {
      slideUp(this.errors);
    }, 5000);
  }

  updateHeaderTotal() {
    axios
      .get(`${window.theme.routes.cart}.js`)
      .then((response) => {
        document.dispatchEvent(
          new CustomEvent('theme:cart:change', {
            detail: {
              cart: response.data,
            },
            bubbles: true,
          })
        );
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

const productAddSection = {
  onLoad() {
    sections[this.id] = [];
    const els = this.container.querySelectorAll(selectors.wrapper);
    els.forEach((el) => {
      sections[this.id].push(new ProductAddButton(el));
    });
  },
  onUnload: function () {
    sections[this.id].forEach((el) => {
      if (typeof el.unload === 'function') {
        el.unload();
      }
    });
  },
};

export {ProductAddButton, productAddSection};
